export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="34" height="27" viewBox="0 0 34 27" fill="none">
            <path
                d="M8.65628 16.9211C3.1823 19.6579 1.58572 23.307 0.445312 25.8158L1.12956 26.5C3.1823 23.7632 4.24287 21.0871 12.0775 17.6053C18.2357 14.8684 22.3412 8.48246 23.7097 5.97368L19.6042 0.5C18.4638 4.83333 14.1303 14.1842 8.65628 16.9211Z"
                fill="url(#paint0_linear_2318_2822)"
            />
            <path
                d="M24.1077 13.6075C20.6505 15.3361 19.6421 17.6408 18.9219 19.2252L19.354 19.6574C20.6505 17.9288 21.3203 16.2387 26.2685 14.0397C30.1579 12.3111 32.7509 8.27788 33.6152 6.69339L31.0222 3.23633C30.302 5.97317 27.565 11.879 24.1077 13.6075Z"
                fill="url(#paint1_linear_2318_2822)"
            />
            <defs>
                <linearGradient id="paint0_linear_2318_2822" x1="21.657" y1="1.18421" x2="0.446582" y2="25.1327" gradientUnits="userSpaceOnUse">
                    <stop offset="0.3" stopColor="#FAE281" />
                    <stop offset="0.46" stopColor="#E87F30" />
                    <stop offset="0.64" stopColor="#FAE281" />
                </linearGradient>
                <linearGradient id="paint1_linear_2318_2822" x1="32.3187" y1="3.66846" x2="18.9227" y2="18.7938" gradientUnits="userSpaceOnUse">
                    <stop offset="0.3" stopColor="#FAE281" />
                    <stop offset="0.46" stopColor="#E87F30" />
                    <stop offset="0.64" stopColor="#FAE281" />
                </linearGradient>
            </defs>
        </svg>
    );
}
